import { Skeleton } from "antd";
import styles from "../../../styles/Components/new-dashboard/DashboardLoaders.module.css";

function MyTasksLoader() {
  return (
    <>
      <div className={styles.tasksLoader}>
        <Skeleton.Node active />
        <Skeleton active paragraph={{ rows: 0 }} />
      </div>
    </>
  );
}

export default MyTasksLoader;
